module.exports = __webpack_public_path__ + "static/img/花瓶12.40e57da.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/reliefVase/imgs/花瓶12.png
// module id = nfj+
// module chunks = 2